/** biome-ignore-all lint/style/useNamingConvention: legacy */
export const GLOBAL_ERRORS = {
  ACHIEVEMENT_NOT_FOUND: 'ACHIEVEMENT_NOT_FOUND',
  ALERT_NOT_FOUND: 'ALERT_NOT_FOUND',
  ASSIGNMENT_NOT_FOUND: 'ASSIGNMENT_NOT_FOUND',
  ASSIGNMENT_MCQ_PAGE_NOT_FOUND: 'ASSIGNMENT_MCQ_PAGE_NOT_FOUND',
  ASSIGNMENT_QUESTION_NOT_FOUND: 'ASSIGNMENT_QUESTION_NOT_FOUND',
  ASSIGNMENT_SUBMISSION_NOT_FOUND: 'ASSIGNMENT_SUBMISSION_NOT_FOUND',
  ASSIGNMENT_ARCHIVE_NOT_FOUND: 'ASSIGNMENT_ARCHIVE_NOT_FOUND',
  CONTENT_PACKAGE_NOT_FOUND: 'CONTENT_PACKAGE_NOT_FOUND',
  COURSE_NOT_FOUND: 'COURSE_NOT_FOUND',
  DISCORD_CATEGORY_NOT_FOUND: 'DISCORD_CATEGORY_NOT_FOUND',
  DISCORD_CATEGORY_ALREADY_EXISTS: 'DISCORD_CATEGORY_ALREADY_EXISTS',
  FEATURE_NOT_AVAILABLE: 'FEATURE_NOT_AVAILABLE',
  LEARNING_RESOURCE_NOT_FOUND: 'LEARNING_RESOURCE_NOT_FOUND',
  LEARNING_RESOURCE_REFERENCE_NOT_FOUND: 'LEARNING_RESOURCE_REFERENCE_NOT_FOUND',
  LESSON_NOT_FOUND: 'LESSON_NOT_FOUND',
  SEQUENCE_NOT_FOUND: 'SEQUENCE_NOT_FOUND',
  USER_BLOCKED: 'USER_BLOCKED',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  CLASS_NOT_FOUND: 'CLASS_NOT_FOUND',
  UPLOAD_NOT_FOUND: 'UPLOAD_NOT_FOUND',
  HELP_ARTICLE_NOT_FOUND: 'HELP_ARTICLE_NOT_FOUND',
  LESSON_RESOURCE_NOT_FOUND: 'LESSON_RESOURCE_NOT_FOUND',
  LESSON_VERSION_MAJOR_NOT_FOUND: 'LESSON_VERSION_MAJOR_NOT_FOUND',
  LESSON_VERSION_NOT_FOUND: 'LESSON_VERSION_NOT_FOUND',
  LESSON_VERSIONS_NOT_FOUND: 'LESSON_VERSIONS_NOT_FOUND',
  LESSON_EDITABLE_VERSION_NOT_FOUND: 'LESSON_EDITABLE_VERSION_NOT_FOUND',
  LESSON_EDITABLE_VERSION_SEQUENCE_NOT_FOUND: 'LESSON_EDITABLE_VERSION_SEQUENCE_NOT_FOUND',
  LESSON_SEQUENCE_NOT_FOUND: 'LESSON_SEQUENCE_NOT_FOUND',
  UPLOAD_INVALID: 'UPLOAD_INVALID',
  SORT_INVALID: 'SORT_INVALID',
  USER_NOT_STUDENT: 'USER_NOT_STUDENT',
  USER_ROLE_NOT_MATCHING: 'USER_ROLE_NOT_MATCHING',
  USER_LESSON_PROGRESS_NOT_FOUND: 'USER_LESSON_PROGRESS_NOT_FOUND',
  LESSON_COMMENT_NOT_FOUND: 'LESSON_COMMENT_NOT_FOUND',
  NOTE_NOT_FOUND: 'NOTE_NOT_FOUND',
  STUDENT_NOT_FOUND: 'STUDENT_NOT_FOUND',
  STATISTICS_NOT_FOUND: 'STATISTICS_NOT_FOUND',
  TEACHER_NOT_IN_CLASS: 'TEACHER_NOT_IN_CLASS',
  TEACHING_UNIT_NOT_FOUND: 'TEACHING_UNIT_NOT_FOUND',
  USER_NOT_AUTHENTICATED: {
    MESSAGE: 'user has not been authenticated',
  },
  TUTOR_NOT_FOUND: 'TUTOR_NOT_FOUND',
  NEWS_NOT_FOUND: 'NEWS_NOT_FOUND',
  STUDENT_HAS_NO_ACCESS: 'STUDENT_HAS_NO_ACCESS',
  STUDENT_ACHIEVEMENT_NOT_FOUND: 'STUDENT_ACHIEVEMENT_NOT_FOUND',
  STUDENT_PAYMENT_REQUESTED: 'STUDENT_PAYMENT_REQUESTED',
  JSON_INVALID: 'JSON_INVALID',
  SIGNATURE_INVALID: {
    MESSAGE: 'Signature is invalid',
  },
  FEATURE_FLAG_DISABLED: 'FEATURE_FLAG_DISABLED',
  FEEDBACK_CAMPAIGN_NOT_FOUND: 'FEEDBACK_CAMPAIGN_NOT_FOUND',
  WALLET_NOT_FOUND: 'WALLET_NOT_FOUND',
} as const;

export const EXTERNAL_SERVICE_ERROR = 'EXTERNAL_SERVICE_ERROR';

export const SYSTEM_ERRORS = {
  JOB_ALREADY_RUNNING: 'JOB_ALREADY_RUNNING',
} as const;

export enum JOI_ERROR_TYPES {
  ANY_INVALID = 'any.invalid',
  ANY_ONLY = 'any.only',
  ANY_REQUIRED = 'any.required',
  ANY_UNKNOWN = 'any.unknown',
  ARRAY_MIN = 'array.min',
  ARRAY_ITEMS_EXACT = 'array.itemsMatch.exact',
  DATE_GREATER = 'date.greater',
  NUMBER_DIVIDABLE = 'number.dividable',
  NUMBER_INTEGER = 'number.integer',
  NUMBER_MAX = 'number.max',
  NUMBER_MIN = 'number.min',
  NUMBER_BASE = 'number.base',
  BOOLEAN_BASE = 'boolean.base',
  OBJECT_AND = 'object.and',
  OBJECT_MIN = 'object.min',
  OBJECT_UNKNOWN = 'object.unknown',
  STRING_EMAIL = 'string.email',
  STRING_EMPTY = 'string.empty',
  STRING_MAX = 'string.max',
  STRING_PATTERN_NAME = 'string.pattern.name',
}

export const EXTRACTION_ERRORS = {
  EXTRACTION_ALREADY_RUNNING: 'EXTRACTION_ALREADY_RUNNING',
};

export const CSV_IMPORT_ERRORS = {
  FILE_REQUIRED: 'CSV_IMPORT_FILE_REQUIRED',
  EMPTY_FILE: 'CSV_IMPORT_EMPTY_FILE',
  INVALID_FILE_TYPE: 'CSV_IMPORT_INVALID_FILE_TYPE',
  INVALID_CSV: 'CSV_IMPORT_INVALID_CSV',
  INVALID_COLUMNS: 'CSV_IMPORT_INVALID_COLUMNS',
  INVALID_ROW: 'CSV_IMPORT_INVALID_ROW',
} as const;
